// extracted by mini-css-extract-plugin
module.exports = {"btn":"x_px d_bQ d_bv f_dw f_dL f_dz f_gs","full":"x_sZ f_cs f_cD"};